import { TaskPhotosEntity } from "tm-shared/types";

export const getPhotoIdsFromPhotoTask = <T extends TaskPhotosEntity>(
    items: Record<string, T>,
) => {
    return Object.values(items)
        .flatMap((item) => item.photos ?? [])
        .filter((photo): photo is string => Boolean(photo));
};
